import React from "react";
import Header from '../components/header';
import Footer from '../components/footer';
import LazyLoad from 'react-lazyload';
import { weddingImages, preweddingImages } from '../constants/images.js';
// css
import '../css/images.scss';

const PageImages = (props) => {
	const [selectedImage, setSelectedImage] = React.useState(null);

	const openPreview = (item) => {
		setSelectedImage(item);
	};

	const closePreview = () => {
		setSelectedImage(null);
	};

	return (
		<>
			<Header />
			
			<div className="page-images">
				<div className="container">
					<h1 className="main-heading">Best Wedding Photos</h1>
					<br/>
					<div className="image-list">
						<div className="card-deck">
							{weddingImages.map((item, index)=>{
								return (
									<div className="card" key={index}>
										<div className="card-image">
											<LazyLoad height={200} offset={300}>
												<img
													src={item?.img}
													alt={item?.title}
													onLoad={(event) => event.currentTarget.classList.add('is-loaded')}
													onClick={() => openPreview(item)}
												/>
											</LazyLoad>
										</div>
									</div>
								)
							})}
						</div>
					</div>
					<br/><br/>
					<h2 className="main-heading">Best Pre-Wedding Photos</h2>
					<div className="image-list">
						<div className="card-deck">
							{preweddingImages.map((item, index)=>{
								return (
									<div className="card" key={index}>
										<div className="card-image">
											<LazyLoad height={200} offset={300}>
												<img
													src={item?.img}
													alt={item?.title}
													onLoad={(event) => event.currentTarget.classList.add('is-loaded')}
													onClick={() => openPreview(item)}
												/>
											</LazyLoad>
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>

			{selectedImage && (
				<div className="image-preview-overlay" onClick={closePreview} role="dialog" aria-modal="true">
					<div className="image-preview" onClick={(event) => event.stopPropagation()}>
						<button
							type="button"
							className="image-preview-close"
							onClick={closePreview}
							aria-label="Close preview"
						>
							×
						</button>
						<img src={selectedImage?.img} alt={selectedImage?.title || 'Preview'} />
					</div>
				</div>
			)}

			<Footer />
		</>
	);
}

export default PageImages